import React from 'react'
import { Icon } from 'components/Icons'
import Spinner from './Spinner'
import styles from './Button.module.scss'

/**
 * Универсальная кнопка с вариантами и состояниями.
 *
 *   <UnvButton variant="primary" iconLeft="plus">Создать</UnvButton>
 *   <UnvButton variant="secondary" loading>Сохранить</UnvButton>
 *   <UnvButton variant="danger" iconLeft="delete">Удалить</UnvButton>
 *   <UnvButton variant="ghost" size="sm" iconOnly icon="edit" aria-label="Изменить" />
 *   <UnvButton variant="link" iconRight="arrow-right">Подробнее</UnvButton>
 */
const VARIANTS = ['primary', 'secondary', 'tertiary', 'ghost', 'danger', 'success', 'link', 'outline']
const SIZES = ['sm', 'md', 'lg']

const UnvButton = React.forwardRef(({
  variant = 'primary',
  size = 'md',
  type = 'button',
  iconLeft,
  iconRight,
  icon,
  iconOnly = false,
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  children,
  onClick,
  ...rest
}, ref) => {
  const v = VARIANTS.includes(variant) ? variant : 'primary'
  const s = SIZES.includes(size) ? size : 'md'

  return (
    <button
      ref={ref}
      type={type}
      onClick={loading || disabled ? undefined : onClick}
      className={[
        styles.btn,
        styles[`v_${v}`],
        styles[`s_${s}`],
        fullWidth ? styles.fullWidth : '',
        iconOnly ? styles.iconOnly : '',
        loading ? styles.loading : '',
        className,
      ].filter(Boolean).join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && <Spinner size={s === 'sm' ? 14 : s === 'lg' ? 20 : 16} color="currentColor" strokeWidth={2.5} />}
      {!loading && iconLeft && <Icon name={iconLeft} size={s === 'sm' ? 14 : s === 'lg' ? 20 : 16} color="currentColor" />}
      {!loading && iconOnly && icon && <Icon name={icon} size={s === 'sm' ? 14 : s === 'lg' ? 20 : 16} color="currentColor" />}
      {!iconOnly && <span className={styles.label}>{children}</span>}
      {!loading && iconRight && <Icon name={iconRight} size={s === 'sm' ? 14 : s === 'lg' ? 20 : 16} color="currentColor" />}
    </button>
  )
})

UnvButton.displayName = 'UnvButton'

export default UnvButton
